import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import classes from './login.module.scss';
import SortpakLogo from '../../../assets/icons/sortpak-logo.png';
import InputField from '../../_common/Form/TextFields/InputField';
import Button from '../../_common/Form/Buttons/Button';
import { getAccountRequest, loginRequest } from '../../../store/actions/auth';
import accountHelpers from '../../../utils/accountHelpers';
import withPublicRouteCheck from '../../../utils/hoc/withPublicRouteCheck';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [data, setData] = useState({
    user: '',
    password: '',
  });

  const { user, password } = data;

  const [requiredError, setRequiredError] = useState({
    user: false,
    password: false,
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const changeData = (path, value) => {
    setData((prev) => ({ ...prev, [path]: value }));
    setRequiredError((prev) => ({ ...prev, [path]: false }));
    setError('');
  };

  const submitLogin = async (e) => {
    e.preventDefault();

    if (!user || !password) {
      _.forEach(data, (val, key) => {
        if (!val) setRequiredError((prev) => ({ ...prev, [key]: true }));
      });

      setError('Please fill this fields');

      return;
    }

    setLoading(true);
    const { payload, status } = await dispatch(loginRequest(data));

    if (status === 'ok') {
      accountHelpers.setToken(payload.data.token);
      accountHelpers.setRefreshToken(payload.data.refreshToken);

      const userId = accountHelpers.getDecodedToken()?.id;
      await dispatch(getAccountRequest(userId));

      if (accountHelpers.isLocked()) {
        setError(`Account locked due to too many wrong password tries. Try agian after
         ${accountHelpers.getLockDate().format('YYYY-MM-DD HH:mm:ss')}`);
      } else if (!accountHelpers.isActive()) {
        setError('This account is not active. Please ask an administrator for more information.');
      } else if (accountHelpers.isInRole('Physician')) {
        navigate('/patients', { replace: true });
      } else {
        navigate('/scripts', { replace: true });
      }
    } else {
      const nowUtcString = moment.utc().format('YYYY-MM-DD HH:mm:ss');

      const ACCOUNT_WRONG_PASSWORD_ATTEMPTS = 3;
      const ACCOUNT_LOCKOUT_MINUTES = 30;

      const wrongPasswordCount = payload?.data?.lockedCount || null;

      const punishmentDeadlineUtcString = payload?.data?.lockedDateTimeUTC
        ? moment(payload?.data?.lockedDateTimeUTC).add('m', ACCOUNT_LOCKOUT_MINUTES)
          .format('YYYY-MM-DD HH:mm:ss')
        : null;

      const accountLocked = punishmentDeadlineUtcString
        && moment(punishmentDeadlineUtcString).isAfter(nowUtcString);

      const triesLeft = wrongPasswordCount
        ? `You have ${ACCOUNT_WRONG_PASSWORD_ATTEMPTS - wrongPasswordCount + 1}`
        : '';

      const message = accountLocked || wrongPasswordCount >= 4
        ? `Account locked due to too many failed login attempts. Account will be unlocked after 
              30 minutes. For any questions, please contact your administrator.`
        : `Wrong username or password! ${triesLeft} ${wrongPasswordCount >= 3 ? 'attempt left' : 'attempts left'}`;

      setError(message);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (localStorage.getItem('successMsg')) {
      toast.success(localStorage.getItem('successMsg'));

      localStorage.removeItem('successMsg');
    }
  }, []);

  return (
    <div className={classes.wrapper}>
      <div className={classes.login_block}>
        <img alt="SortPak" src={SortpakLogo} className={classes.icon} />

        <h2 className={classes.title}>Welcome to SortPak</h2>

        <form onSubmit={submitLogin}>
          <div className={classes.inputs_wrapper}>
            <InputField
              label="Username or Email"
              value={user}
              onChange={(value) => changeData('user', value)}
              error={requiredError.user}
            />

            <InputField
              label="Password"
              value={password}
              type="password"
              onChange={(value) => changeData('password', value)}
              error={requiredError.password}
            />

            {error && <div className={classes.error}>{error}</div>}
          </div>

          <Button
            title="Login"
            className={classes.btn}
            type="submit"
            loading={loading}
          />
        </form>
      </div>
    </div>
  );
};

Login.propTypes = {

};

export default withPublicRouteCheck(Login);
